import { atom } from 'recoil'
import { IFullTeam } from '../../../Teams/teams.types'

interface ISelfTeamsState {
  loaded: boolean
  items: IFullTeam[]
}

const selfTeamsAtom = atom<ISelfTeamsState>({ key: '/self/teams', default: { items: [], loaded: false } })
export default selfTeamsAtom
